import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface StorageChange {
  key: string;
  value: string | null;
  storageArea: 'localStorage' | 'sessionStorage';
}

export interface StorageGetItem {
  key: string;
  storageArea: 'localStorage' | 'sessionStorage';
}

@Injectable({ providedIn: 'root' })
export class StorageService {
  public storageChange$: Subject<StorageChange> = new Subject();

  public setStorageItem(change: StorageChange): void {
    if (!change?.value) this.removeStorageItem(change); // allow passing of value: null to remove the item completely

    window[change.storageArea].setItem(change.key, change.value as string);

    this.storageChange$.next(change);
  }

  public getStorageItem(getItem: StorageGetItem): string | null {
    return window[getItem.storageArea].getItem(getItem.key);
  }

  public removeStorageItem(change: StorageChange): void {
    window[change.storageArea].removeItem(change.key);
    change.value = null;
    this.storageChange$.next(change);
  }
}
